import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface BachelorDegreeReturn {
  mode: ComputedRef<InputMode>
  label: string
  setBachelorDegree: (value: boolean) => void
}

export const useBachelorDegree = (): BachelorDegreeReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'Do you have a bachelor degree in education (or a similar field)?'

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && tutorApplicationStore.form.hasBachelorDegree === null))

  const setBachelorDegree = (value: boolean): void => {
    tutorApplicationStore.setField('hasBachelorDegree', value)
  }

  return {
    mode,
    label,
    setBachelorDegree,
  }
}
